import React from 'react';

import Modal from "react-modal";
import Button from '../../forms/buttons/Button';

import './User.deactivate.dialog.scss';
import { useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../../services/graphql.schemas';
import {useTranslation} from "react-i18next";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        width: '670px',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        overflow: 'visible',
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};

Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

export default function UserDisableModal({ clinician, disableRequested, closeDisable, closeUpdateDisabled }) {
    const {t} = useTranslation(['users','common'])
    const [deactivateUser] = useMutation(gqlSchemaLibrary.clinicians.mutations.deactivateUser, {
        onCompleted: ({ deactivateUser }) => {
            console.log('deactivateUser: ', deactivateUser);
            closeUpdateDisabled(deactivateUser);
        }
    })
    const [reactivateUser] = useMutation(gqlSchemaLibrary.clinicians.mutations.reactivateUser, {
        onCompleted: ({ reactivateUser }) => {
            console.log('reactivateUser: ', reactivateUser);
            closeUpdateDisabled(reactivateUser);
        }
    })

    const closeAndDisable = () => {
        if(clinician.user.isDisabled){
            AuditTrail.sendLog(PAGES.USERS_LIST, {tab: 'button', event: 'onClick', action: 'button modal reactivate user', user_id: clinician._id});
            reactivateUser({
                variables: {
                    userId: clinician.userId
                }
            })
        }else {
            AuditTrail.sendLog(PAGES.USERS_LIST, {tab: 'button', event: 'onClick', action: 'button modal deactivate user', user_id: clinician._id});
            deactivateUser({
                variables: {
                    userId: clinician.userId
                }
            })
        }
    }

    return (
        <_Modal
            isOpen={disableRequested}
            onRequestClose={closeDisable}
            style={customStyles}
            label="modalActivateOrInactiveUser"
            event={PAGES.PARTICIPANTS_LIST}
            eventParams={{user_id: clinician? clinician._id : null}}>
            <div className="modalDisable">
                <div className="modalHeader">
                    <div className="_title">

                    </div>
                    <div className="iconClose">
                        <span className="material-icons" onClick={closeDisable}>
                            close
                        </span>
                    </div>
                </div>
                <div className="modalBody">
                    <div className={`iconHolder ${clinician.user.isDisabled ? 'reactivate' : ''}`}>
                        <span className="material-icons">
                            warning
                        </span>
                    </div>
                    <div>
                        <h2>
                            {t('activate-text-1')} {clinician.user.isDisabled ? t('reactivate') : t('deactivate')} {t('user')} <br />
                            <b>{clinician.user.bio.firstname} {clinician.user.bio.lastname}</b> ?
                        </h2>
                        <p>

                            {t('activate-text-2')} {clinician.user.isDisabled ? t('re-gain') : t('lose')} {t('activate-text-3')}
                            {t('activate-text-4')} {clinician.user.isDisabled ? t('deactivating') : t('activating')} {t('activate-text-5')}
                        </p>
                    </div>
                </div>
                <div className="actions">
                    <Button className={'cancel'} handleClick={closeDisable}>
                        {t('common:cancel')}
                    </Button>
                    <Button className={'submit'} handleClick={closeAndDisable}>
                    {clinician.user.isDisabled ? t('activate') : t('deactivate')} {t('account')}
                    </Button>
                </div>
            </div>
        </_Modal>
    )
}
